<template>
  <v-layout>
    <v-flex sm1>
      <v-icon v-if="cuentaBanco.activo" color="pink">star</v-icon>
      <v-chip v-if="!cuentaBanco.activo" small color="grey">baja</v-chip>
    </v-flex>

    <v-flex sm9>
      <div>{{ cuentaBanco.cbu }} - {{ cuentaBanco.entidadFinanciera }}</div>
    </v-flex>

    <v-spacer></v-spacer>
    <v-flex sm1>
      <v-tooltip bottom v-if="showEdit">
        <template v-slot:activator="{ on }">
          <v-btn icon small v-on="on" @click="editar">
            <v-icon color="red lighten-2">edit</v-icon></v-btn
          >
        </template>
        <span>Editar</span>
      </v-tooltip>
    </v-flex>
    <v-flex sm1>
      <v-tooltip bottom v-if="showDelete">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            v-on="on"
            @click="eliminar"
            v-if="checkCanAccess('ap-puede-anular-cbu')"
          >
            <v-icon color="grey">delete</v-icon></v-btn
          >
        </template>
        <span>Dar de Baja</span>
      </v-tooltip>
    </v-flex>

    <v-dialog v-model="editModeOn" width="800" persistent>
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline" primary-title
          >Edición de Cuenta Bancaria</v-card-title
        >

        <v-container fluid grid-list-lg>
          <v-row align="center">
            <!-- <v-col cols="2">
                            <v-switch v-model="cuentaBancoEditor.esAlias" label="Es Alias" v-validate="'required'" data-vv-name="es Alias"></v-switch>
                        </v-col> -->

            <v-col v-if="cuentaBancoEditor.esAlias == false" cols="4">
              <v-text-field
                v-model="cuentaBancoEditor.cbu"
                label="CBU/CVU"
                v-validate="'required'"
                data-vv-name="cbu"
                counter
              >
                <template v-slot:append v-if="!cuentaBancoEditor.cbuValidado">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" @click="validarCbu"
                        >help_outline</v-icon
                      >
                    </template>
                    Validar CBU
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>

            <v-col v-if="cuentaBancoEditor.esAlias == true" cols="4">
              <v-text-field
                v-model="cuentaBancoEditor.cbu"
                label="Alias de la Cuenta"
                v-validate="'required'"
                data-vv-name="alias"
              ></v-text-field>
            </v-col>

            <v-col v-if="cuentaBancoEditor.cbuValidado">
              <v-icon color="green">check</v-icon>
            </v-col>

            <v-col cols="3" v-if="resultadoValidacion.esValido == false">
              <v-chip class="caption" color="red" dark>{{
                resultadoValidacion.motivoNoValida
              }}</v-chip>
            </v-col>

            <v-col
              cols="3"
              v-if="
                resultadoValidacion.esValido == true &&
                cuentaBancoEditor.entidadFinanciera
              "
            >
              <div class="caption">
                {{ cuentaBancoEditor.entidadFinanciera }}
              </div>
            </v-col>

            <v-col>
              <v-switch
                v-model="cuentaBancoEditor.activo"
                label="Activo"
                v-validate="'required'"
                data-vv-name="activo"
                :disabled="!checkCanAccess('ap-puede-anular-cbu')"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-autocomplete
                v-model="cuentaBancoEditor.tipoCuentaId"
                :items="tiposCuenta"
                item-text="descripcion"
                item-value="id"
                label="Tipo Cuenta"
                placeholder="Seleccione el tipo de cuenta"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="cuentaBancoEditor.sucursalBanco"
                label="Sucursal Banco"
                data-vv-name="sucursalBanco"
                hint="opcional"
              ></v-text-field>
            </v-col>
            <v-col cols="4" v-show="false">
              <v-switch
                v-model="cuentaBancoEditor.esDeOtroTitular"
                label="Pertenece a Otro Titular"
                v-validate="'required'"
                data-vv-name="esDeOtroTitular"
              ></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col v-if="cuentaBancoEditor.esDeOtroTitular == true" cols="3">
              <v-text-field
                v-model="cuentaBancoEditor.cuilTitular"
                label="CUIL del Titular de la Cuenta"
                data-vv-name="cuil titular"
              ></v-text-field>
            </v-col>
            <v-col v-if="cuentaBancoEditor.esDeOtroTitular == true">
              <v-text-field
                v-model="cuentaBancoEditor.nombreTitular"
                label="Nombre del Titular de la Cuenta"
                data-vv-name="nombre titular"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="accent" text @click="cancelar()"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirmarModificacion()">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>

      <template v-if="$store.state.debugModeOn">
        Debug Info:
        <p></p>

        Editor: {{ cuentaBancoEditor }}
        <p></p>
        Origen: {{ cuentaBanco }}
        <p></p>
        Validacion: {{ resultadoValidacion }}
        <p></p>
      </template>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    editModeOn: false,
    loading: false,
    cuentaBanco: {},
    cuentaBancoEditor: {
      tipoCuentaId: 1,
      cbu: null,
      esAlias: false,
      activo: true,
      esDeOtroTitular: false,
      cbuValidado: false,
      motivoBaja: '',
    },
    tiposCuenta: [],
    esPredeterminado: false,
    resultadoValidacion: { esValido: true },
  }),
  props: {
    value: {
      type: Object,
      required: false,
    },
    cuentasExistentes: {
      type: Array,
      required: false,
    },
    propName: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      default: 'cuentaBanco',
    },
    iconName: {
      type: String,
      default: 'home',
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    setPredeterminado: Function,
  },
  watch: {
    'cuentaBancoEditor.activo': async function () {
      if (this.editModeOn && this.cuentaBancoEditor.activo == false) {
        this.cuentaBancoEditor.motivoBaja = await this.$dialog.prompt({
          text: 'Ingrese el Motivo de la Baja',
          title: 'Confirmar Operación',
          persistent: true, // Parece que no funciona...
        });
      }
    },
    'value.cuentaBanco': function (item) {
      console.log('xxxxx ');
      this.cuentaBanco = item;
      this.setCuenta();
    },
    'cuentaBancoEditor.cbu': function () {
      this.cuentaBancoEditor.cbuValidado = false;
      this.cuentaBancoEditor.banco = '';
    },
  },
  computed: {
    ...mapGetters(['checkCanAccess']),
  },
  created() {
    // todo: cargar tipos de cuenta
    this.loadTipoCuenta();

    // cargo el modelo
    this.setCuenta();
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    setCuenta() {
      if (this.propName == '') {
        this.cuentaBanco = this.value;
        this.copiarCuenta(this.value, this.cuentaBancoEditor); // hago una copia para poder modificarlo asi afectar al original
      } else {
        if (!this.value[this.propName]) {
          // Si no está cargada, creo la propiedad
          this.cuentaBanco = {
            activo: true,
            esAlias: false,
            cbu: '',
            cbuValidado: false,
            esDeOtroTitular: false,
            tipoCuentaId: 1,
            sucursalBanco: null,
            cuilTitular: null,
            nombreTitular: null,
            fechaAlta: Date.now(),
          };

          this.value[this.propName] = this.cuentaBanco;
        }
        this.cuentaBanco = this.value[this.propName];
      }
    },
    copiarCuenta(source, destination) {
      destination.activo = source.activo;
      destination.esAlias = source.esAlias;
      destination.cbu = source.cbu;
      destination.esDeOtroTitular = source.esDeOtroTitular;
      destination.tipoCuentaId = source.tipoCuentaId;
      destination.sucursalBanco = source.sucursalBanco;
      destination.cuilTitular = source.cuilTitular;
      destination.nombreTitular = source.nombreTitular;
      destination.fechaAlta = source.fechaAlta;
      destination.entidadFinanciera = source.entidadFinanciera;
      destination.cbuValidado = source.cbuValidado;
      destination.motivoBaja = source.motivoBaja;
      destination.id = source.id;
    },
    eliminar() {
      this.$parent.$parent.$parent.$parent.deleteChild(this.cuentaBanco); // cuando está dentro de una lista hay toda una jerarquía...
    },
    async validarCbu() {
      this.loading = true;
      try {
        var result = await http.get(
          'BusinessCore/validarcbu' +
            '?cbu=' +
            this.cuentaBancoEditor.cbu +
            '&esAlias=' +
            this.cuentaBancoEditor.esAlias
        );

        this.resultadoValidacion = result;

        this.cuentaBancoEditor.cbuValidado = result.esValido;
        this.cuentaBancoEditor.entidadFinanciera = result.banco;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    async loadTipoCuenta() {
      this.loading = true;
      try {
        var result = await http.get('tiposcuentabanco'); // traigo todas
        this.tiposCuenta = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
      }
      this.loading = false;
    },
    editar() {
      this.copiarCuenta(this.cuentaBanco, this.cuentaBancoEditor);
      this.editModeOn = true;
    },
    async confirmarModificacion() {
      // valido
      await this.$validator.validateAll();

      if (!this.cuentaBancoEditor.cbuValidado) {
        this.alertWarning(
          'Por favor, valide el CBU de la cuenta antes de confirmar.'
        );
        return;
      }

      var cbuExistente = this.cuentasExistentes.find(
        (x) =>
          x.cbu == this.cuentaBancoEditor.cbu &&
          x.id != this.cuentaBancoEditor.id
      );
      if (cbuExistente) {
        this.alertWarning(
          'El cbu ingresado ya existe ' +
            (!cbuExistente.activo ? '(Está dado de Baja)' : '') +
            '.'
        );
        return;
      }

      if (this.errors.items.length > 0) {
        Vue.$log.debug('validation:');
        Vue.$log.debug(this.errors.items.length);
        Vue.$log.debug(this.errors.items);
        Vue.$log.debug(this.errors);
        return;
      }

      //this.copiarCuenta(this.cuentaBancoEditor, this.cuentaBanco);

      var cuentaExistente = this.cuentasExistentes.find(
        (x) => x.id == this.cuentaBancoEditor.id
      );
      if (cuentaExistente) {
        this.copiarCuenta(this.cuentaBancoEditor, cuentaExistente);
      }

      this.editModeOn = false;
      this.$emit('close-dialog');
    },

    cancelar() {
      Vue.$log.debug(this.cuentaBanco);
      if (!this.cuentaBanco.id) {
        this.$emit('cancelar-ingreso', this.cuentaBanco.orden);
      }
      this.editModeOn = false;
    },
  },
};
</script>
